// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Icon_hidden__jAN3C","link":"Icon_link__30y9y"};